import dayjs, { type Dayjs } from '@/utilities/dayjs-config'
import type { DiscountOptionWeek as PopsDiscountOptionWeek } from '@/types/pops'

export class DiscountOptionWeek {
  discountOptionId: number
  optionType: string
  startWeek: Dayjs
  week: Dayjs

  constructor(rawDiscountOptionWeek: PopsDiscountOptionWeek) {
    this.discountOptionId = rawDiscountOptionWeek.discount_option_id
    this.optionType = rawDiscountOptionWeek.option_type
    this.startWeek = dayjs(rawDiscountOptionWeek.start_week)
    this.week = dayjs(rawDiscountOptionWeek.week)
  }
}
